import { mapMonolithCartToStripeCart } from '@app/components/Stripe';
import {
  useCartAndDeliveryDatesDataContext,
  useUpdateShippingPreference,
} from '@app/data/clients/cartCheckoutClient';
import { ShippingMethod } from '@app/types/cart/ShippingMethod';
import { CartQueryShippingAddress } from '@app/types/monolith/types';
export const useStripeShippingPreferenceChangeHandler = () => {
  const { dispatch, client } = useCartAndDeliveryDatesDataContext();

  const { handler: handleUpdateShippingPreference } =
    useUpdateShippingPreference({ client, dispatch });

  const handleShippingPreferenceChange = async (
    shippingMethod: ShippingMethod,
    shippingAddress?: CartQueryShippingAddress
  ) => {
    const result = await handleUpdateShippingPreference(
      shippingMethod,
      shippingAddress
    );

    if (result.state === 'FAILED' || !result?.data) {
      const errorMessage =
        result.errors?.[0]?.exception || 'Failed to update shipping preference';
      throw new Error(errorMessage);
    }

    return mapMonolithCartToStripeCart(result.data);
  };

  return { handleShippingPreferenceChange };
};
